export default __webpack_public_path__ + "static/media/cardDealSFX.a753dc78.mp3";